import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  withRouter,
  Link,
} from "react-router-dom";
import NluTab from "./nlu/tabs";
import ProjectSettings from "./settings/ProjectSettings";
import Faq from "./faq/Faq";
import ReportSettings from "./reports/reportSettings";
import MultiLingualTab from "./MultiLingualData/MultiLingualTabs";
import deploySettings from "./testAndDeploy/deploySettings";
import Transition from "./nlu/transition/transition";
import MapHandlerAndIntent from "./nlu/transition/MapHandlerAndIntent";
import HandlerMappingDetails from "./nlu/transition/HandlerMappingDetails";
import SluSlotDetails from "./nlu/intent/Slots";
import SluTemplate from "./nlu/intent/Templates";
import SluPrompts from "./nlu/intent/Prompts";
import SluTriggerDetails from "./nlu/intent/Trigger";
import FaqOtherFormDetails from "./faq/OtherFormsReact";
import FaqAnswerDetails from "./faq/Answers";
import ContentDetails from "./faq/ContentDetails";
import StopTrigger from "./nlu/intent/StopTrigger";
import GraphicalRep from "./nlu/transition/GraphicalRep";

import $ from "jquery";
import FaqSubTabSetting from "./faq/FaqSubTabSetting";
import OutboundCallTask from "./testAndDeploy/OutboundCallTask";
import { getDropEventArguements } from "@syncfusion/ej2-react-diagrams";

class LeftPanel extends Component {
  constructor() {
    super();
    this.state = {
      showOnlyReport: false,
    };
  }
  componentDidMount() {
    var localController = this;
    localController.loadroles();
    document.addEventListener("projectChanged", function (event) {
      localController.projectId = event.projectId;
      localController.loadroles(event.projectId);
      localStorage.removeItem("reload");
      if (localController.state.showOnlyReport) {
        window.location.href = "/platform/projectmgmt/reports";
      }
    });

    (function () {
      var currentPath = window.location.href;
      var projectSettingsPathExist = false;
      var projectSettingsTabsPatterns = [
        "/bot-store",
        "/team-setting",
        "/billing-setting",
        "/payment-gateway",
        "/emailer-settings",
        "/api-keys",
        "/import-export",
        "/custom-settings",
        "/look-and-feel",
        "/voice",
        "/domain",
        "/avatar-settings",
      ];
      for (var i = 0; i < projectSettingsTabsPatterns.length; i++) {
        if (currentPath.includes(projectSettingsTabsPatterns[i]) == true) {
          projectSettingsPathExist = true;
          break;
        }
      }
      var path = window.origin + "/platform/projectmgmt/";
      var path1 = window.origin + "/platform/projectmgmt";
      if (
        currentPath == path ||
        currentPath == path1 ||
        projectSettingsPathExist
      ) {
        $("#left-panel-menu-projectSetting").addClass("activemenu");
      } else if (currentPath.includes("/manage-knowledge")) {
        $("#left-panel-menu-faq").addClass("activemenu");
      } else if (currentPath.includes("/nlutab")) {
        $("#left-panel-menu-nlu").addClass("activemenu");
      } else if (currentPath.includes("/multilingual")) {
        $("#left-panel-menu-multilingual").addClass("activemenu");
      } else if (currentPath.includes("/test-and-deploy")) {
        $("#left-panel-menu-deploy").addClass("activemenu");
      } else if (currentPath.includes("/reports")) {
        $("#left-panel-menu-reports").addClass("activemenu");
      } else {
        $("#" + localStorage.getItem("last-used-left-panel-tab")).addClass(
          "activemenu"
        );
      }

      //Onclick Agent Setting tab
      $("#left-panel-menu-projectSetting").on("click", function () {
        $(
          "#left-panel-menu-projectSetting,#left-panel-menu-multilingual,#left-panel-menu-faq,#left-panel-menu-nlu," +
            "#left-panel-menu-deploy,#left-panel-menu-reports"
        ).removeClass("activemenu");
        localStorage.setItem("last-used-left-panel-tab", $(this)[0].id);
        $(this).addClass("activemenu");

        $(
          "#bot-store,#custom-settings-tab,#basicsettings,#look-and-feel,#custom-settings-tab,#look-and-feel-tab," +
            "#team-tab,#import-export,#api-keys,#payment-tab,#emailer-settings,#billing-setting,#language,#domain," +
            "#voice,#avatar-settings,#bot-store"
        ).removeClass("active");
        localStorage.setItem("last-project-settings-tab", $(this)[0].id);
        $("#basicsettings,#language").addClass("active");
      });

      //Onclick Knowledge Management tab
      $("#left-panel-menu-faq").on("click", function () {
        $(
          "#left-panel-menu-projectSetting,#left-panel-menu-multilingual,#left-panel-menu-faq,#left-panel-menu-nlu," +
            "#left-panel-menu-deploy,#left-panel-menu-reports"
        ).removeClass("activemenu");
        localStorage.setItem("last-used-left-panel-tab", $(this)[0].id);
        $(this).addClass("activemenu");

        $("#manage-knowlegde-document,#manage-knowlegde-faq").removeClass(
          "active"
        );
        localStorage.setItem("last-used-faq-settings-sub-tab", $(this)[0].id);
        $("#manage-knowlegde-document").addClass("active");
      });

      //Onclick Intents and Automations tab
      $("#left-panel-menu-nlu").on("click", function () {
        $(
          "#left-panel-menu-projectSetting,#left-panel-menu-multilingual,#left-panel-menu-faq,#left-panel-menu-nlu," +
            "#left-panel-menu-deploy,#left-panel-menu-reports"
        ).removeClass("activemenu");
        localStorage.setItem("last-used-left-panel-tab", $(this)[0].id);
        $(this).addClass("activemenu");

        $("#intent-tab,#dsm-tab,#backend-api-tab").removeClass("active");
        localStorage.setItem("last-used-nlu-tab", $(this)[0].id);
        $("#intent-tab").addClass("active");
      });

      //Onclick Entities and other data tab
      $("#left-panel-menu-multilingual").on("click", function () {
        $(
          "#left-panel-menu-projectSetting,#left-panel-menu-multilingual,#left-panel-menu-faq,#left-panel-menu-nlu," +
            "#left-panel-menu-deploy,#left-panel-menu-reports"
        ).removeClass("activemenu");
        localStorage.setItem("last-used-left-panel-tab", $(this)[0].id);
        $(this).addClass("activemenu");

        $(
          "#entities-tab,#translation-tab,#substitution-tab,#mlt-tab,#abbreviation-tab,#mlcd-tab,#named-entity-tab," +
            "#custom-entity-type-tab"
        ).removeClass("active");
        localStorage.setItem("last-multilingual-data-tab", $(this)[0].id);
        $("#entities-tab,#mlcd-tab").addClass("active");
      });

      //Onclick Test and Deploy tab
      $("#left-panel-menu-deploy").on("click", function () {
        $(
          "#left-panel-menu-projectSetting,#left-panel-menu-multilingual,#left-panel-menu-faq,#left-panel-menu-nlu," +
            "#left-panel-menu-deploy,#left-panel-menu-reports"
        ).removeClass("activemenu");
        localStorage.setItem("last-used-left-panel-tab", $(this)[0].id);
        $(this).addClass("activemenu");

        $("#build-tab,#test-tab,#distributionWidget-tab").removeClass("active");
        localStorage.setItem("last-deploy-settings-tab", $(this)[0].id);
        $("#build-tab").addClass("active");
      });

      //Onclick Reports tab
      $("#left-panel-menu-reports").on("click", function () {
        $(
          "#left-panel-menu-projectSetting,#left-panel-menu-multilingual,#left-panel-menu-faq,#left-panel-menu-nlu," +
            "#left-panel-menu-deploy,#left-panel-menu-reports"
        ).removeClass("activemenu");
        localStorage.setItem("last-used-left-panel-tab", $(this)[0].id);
        $(this).addClass("activemenu");

        $(
          "#kpi-tab,#generate-report-tab,#conversation-log-tab,#statistics-tab,#settings-tab,#audit-tab,#bot-store-tab,#telephony-outreach-tab," +
            "#daily-reports,#monthly-conv-data,#weekly-conv-data,#output-spreadsheets,#summary"
        ).removeClass("active");
        localStorage.setItem("last-used-report-settings-tab", $(this)[0].id);
        $("#statistics-tab,#summary").addClass("active");
      });
    })();
  }
  loadroles = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    var localController = this;
    localController.state.showOnlyReport = false;
    localController.setState(localController.state);
    $.ajax({
      url: "/api/project-membership",
      async: false,
      method: "GET",
      data: {
        projectId: projectId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          var myUserId = JSON.parse(localStorage.getItem("user_details"))[
            "userId"
          ];
          for (var i = 0; i < res.result.length; i++) {
            if (res.result[i].userId == myUserId) {

              /* Saving project role in local storage */
              localStorage.setItem("PROJECT_ROLE", res.result[i].role);

              if(res.result[i].role == "SALES_MANAGER") {
                localController.state.showOnlyReport = true;
                localController.setState(localController.state);
                // hide the manage button for sales manager
                var button = document.getElementById("manage");
                  if ( button ) { 
                    button.style.display = "none";
                  }
                
               // localController.props.history.push("/projectmgmt/reports");
                if( !localStorage.getItem("reload") || localStorage.getItem("reload") == "false") {
                  localStorage.setItem("reload", true);
                  
                  window.location.href = "/platform/projectmgmt/reports"
                }
                break;
              }
            } else { 
              // show the manage button if role changes for the project
              var button = document.getElementById("manage");
                if ( button ) { 
                  button.style.display = "block";
                }

            }
          }
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      },
    });
  };

  render() {
    return (
      <Router basename={window.contextPath}>
        <div>
          <link
            rel="stylesheet"
            href="./plugins/font-awesome/css/font-awesome.min.css"
          />
          <link
            rel="stylesheet"
            href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css"
          />
          <link rel="stylesheet" href="./assets/css/adminlte.css" />
          <link rel="stylesheet" href="./assets/css/styles.css" />
          <link rel="stylesheet" href="./assets/css/custom-style.css" />
          <link rel="stylesheet" href="./plugins/iCheck/all.css" />
          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link
            href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css"
            rel="stylesheet"
          />
          <link href="assets/css/scrollbar.css" rel="stylesheet" />
          <div className="content-wrapper">
            <div
              className="left-menu"
              style={{ marginTop: "0px", position: "absolute", height: "auto" }}
            >
              <ul id="floatMenu">
                <Link to="/projectmgmt">
                  <li
                    id="left-panel-menu-projectSetting"
                    className="tabs"
                    style={{
                      display: this.state.showOnlyReport ? "none" : "block",
                    }}
                  >
                    <i className="fa flaticon-ui" />
                    <span>Agent Settings</span>
                  </li>
                </Link>
                <Link
                  to="/projectmgmt/manage-knowledge"
                  style={{
                    display: this.state.showOnlyReport ? "none" : "block",
                  }}
                >
                  <li id="left-panel-menu-faq" className="tabs">
                    <i className="fa flaticon-ui" />
                    <span>Knowledge Management</span>
                  </li>
                </Link>
                <Link
                  to="/projectmgmt/nlutab"
                  style={{
                    display: this.state.showOnlyReport ? "none" : "block",
                  }}
                >
                  <li id="left-panel-menu-nlu" className="tabs">
                    <i className="fa flaticon-ui" />
                    <span>Intents &amp; Automations</span>
                  </li>
                </Link>

                <Link
                  to="/projectmgmt/multilingual"
                  style={{
                    display: this.state.showOnlyReport ? "none" : "block",
                  }}
                >
                  <li id="left-panel-menu-multilingual" className="tabs">
                    <i className="fa flaticon-ui" />
                    <span>Entities &amp; Other Data</span>
                  </li>
                </Link>

                <Link to="/projectmgmt/test-and-deploy">
                  <li
                    id="left-panel-menu-deploy"
                    className="tabs"
                    style={{
                      display: this.state.showOnlyReport ? "none" : "block",
                    }}
                  >
                    <i className="fa flaticon-ui" />
                    <span>Test &amp; Deploy</span>
                  </li>
                </Link>
                <Link to="/projectmgmt/reports">
                  <li id="left-panel-menu-reports" className="tabs">
                    <i className="fa flaticon-ui" />
                    <span>Reports</span>
                  </li>
                </Link>
              </ul>
            </div>
          </div>
          <Switch>
            <Route
              path="/projectmgmt/outbound-call-task"
              component={OutboundCallTask}
            ></Route>
            <Route
              path="/projectmgmt/slu-stop-trigger"
              component={StopTrigger}
            ></Route>
            <Route
              path="/projectmgmt/faq-otherForms-details"
              component={FaqOtherFormDetails}
            ></Route>
            <Route
              path="/projectmgmt/faq-answer-details"
              component={FaqAnswerDetails}
            ></Route>
            <Route
              path="/projectmgmt/content-details"
              component={ContentDetails}
            ></Route>
            <Route
              path="/projectmgmt/slu-trigger-details"
              component={SluTriggerDetails}
            ></Route>
            <Route
              path="/projectmgmt/slu-slot-details"
              component={SluSlotDetails}
            ></Route>
            <Route
              path="/projectmgmt/slu-template"
              component={SluTemplate}
            ></Route>
            <Route
              path="/projectmgmt/slu-prompt"
              component={SluPrompts}
            ></Route>
            <Route
              path="/projectmgmt/map-handler-and-intent"
              component={MapHandlerAndIntent}
            ></Route>
            <Route
              path="/projectmgmt/handler-mappig-details"
              component={HandlerMappingDetails}
            ></Route>
            <Route
              path="/projectmgmt/transition"
              component={Transition}
            ></Route>
            <Route path="/projectmgmt/graph" component={GraphicalRep}></Route>
            <Route
              path="/projectmgmt/manage-knowledge"
              component={FaqSubTabSetting}
            ></Route>
            <Route path="/projectmgmt/nlutab" component={NluTab}></Route>
            <Route
              path="/projectmgmt/multilingual"
              component={MultiLingualTab}
            ></Route>
            
            <Route
              path="/projectmgmt/test-and-deploy"
              component={deploySettings}
            ></Route>
            {/* <Route path="/projectmgmt/reports" component={ReportSettings}></Route> */}
            {/* Pass showOnlyReport as a prop to the reportSettings component */}
            <Route
              path="/projectmgmt/reports"
            >
           <ReportSettings showOnlyReport={this.state.showOnlyReport} />
            </Route>
           
              <Route path="/projectmgmt" component={ProjectSettings}></Route>
            
          </Switch>
        </div>
      </Router>
    );
  }
}
export default LeftPanel;



// WEBPACK FOOTER //
// ./src/projectmgmt/LeftPanel.js